import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  chip: {
    maxWidth: '100%',
    fontWeight: 500,
    '& .MuiChip-label': {
      maxWidth: 280,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  tooltip: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: 'break-all',
  },
}))

export default useStyles
